const Login = () => import(/* webpackChunkName: "Login" */ '@/views/Public/Pages/Login')
const ForgottenPassword = () => import(/* webpackChunkName: "ForgottenPassword" */ '@/views/Public/Pages/ForgottenPassword')
const ResetPassword = () => import(/* webpackChunkName: "ResetPassword" */ '@/views/Public/Pages/ResetPassword')

export default [
    {
        path: '/',
        component: Login
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/forgotten-password',
        component: ForgottenPassword
    },
    {
        path: '/reset-password',
        component: ResetPassword
    }
]
